import { render, staticRenderFns } from "./TeamResultCard.vue?vue&type=template&id=52501ab6&scoped=true"
import script from "./TeamResultCard.vue?vue&type=script&lang=js"
export * from "./TeamResultCard.vue?vue&type=script&lang=js"
import style0 from "./TeamResultCard.vue?vue&type=style&index=0&id=52501ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52501ab6",
  null
  
)

export default component.exports